export const scrollpanelTheme = {
  root: {
    transitionDuration: '0.2s'
  },
  bar: {
    size: '4px',
    borderRadius: '4px',
    focusRing: {
      width: '0px',
      style: 'solid',
      color: 'transparent',
      offset: '0px',
      shadow: 'none'
    }
  },
  colorScheme: {
    light: {
      bar: {
        background: 'rgba(0, 0, 0, 0.2)'
      }
    },
    dark: {
      bar: {
        background: 'rgba(255, 255, 255, 0.2)'
      }
    }
  }
};
